module.exports = __webpack_public_path__ + "515114a39ca8ab4a0d55011d80217abd.jpg";